import MuiButton from "@material-ui/core/Button";
import MuiCircularProgress from "@material-ui/core/CircularProgress";
import spacing from "@material-ui/system/spacing";

import React from "react";
import styled from "styled-components";

const Button = styled(MuiButton)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);

const ButtonWithLoading = ({
  children,
  loading,
  disabled = false,
  ...props
}) => {
  return (
    <Button {...props} disabled={loading || disabled}>
      {children}
      {loading && (
        <CircularProgress
          ml={3}
          color="inherit"
          size="1rem"
          data-testid="button-loading-indicator"
        />
      )}
    </Button>
  );
};

export default ButtonWithLoading;
